<template>
  <div class="realEstate">

    <div class="edit-area">

      <h2 class="normal">高架线路</h2>

      <div class="edit-area-content">
        <el-button @click="reverseLine" type="info">反转</el-button>
        <el-button @click="sortStations" type="info">站点排序</el-button>
        <div class="normal">线路名：<input type="text" v-model="name"></div>
        <div class="normal">状态：
          <el-radio v-model="status" label="规划">规划</el-radio>
          <el-radio v-model="status" label="建成">建成</el-radio>
        </div>
        <div class="normal">类别：
          <select name="" id="" v-model="type">
            <option value="快速路">快速路</option>
            <option value="隧道">隧道</option>
            <option value="高架">高架</option>
            <option value="高速">高速</option>
            <option value="铁路">铁路</option>
            <option value="高铁">高铁</option>
          </select>
        </div>

        <div class="normal">
          模式
          <button @click="changeMode('出入口')" :class="{'bgred': mode === '出入口'}">出入口</button>
          <button @click="changeMode('线路名')" :class="{'bgred': mode === '线路名'}">线路名</button>
        </div>

        <div class="normal" v-for="(station,index) in stationList" :key="index" @click="changeCenter(station)">
          <div>站名:<span :style="{'background-color': station.goto?'yellow':'white'}">{{station.name}}</span></div>
          <button @click.stop="del(index)">删除</button>
          <button @click.stop="rename1(index)">修改</button>
          <button @click.stop="toTop(index)">置顶</button>
          <div v-if="showRenameInput === index">
            <input type="text" v-model="station.name" @keydown.enter="rename2(index)" @click.stop v-focus
              @blur="loseFocus">
          </div>
        </div>

        <button @click="upToDb" class="up">上传数据库</button>

        <div style="margin-top: 50px;">
          <el-button type="primary" @click="startChai" v-if="!chaifen">开始拆分</el-button>
        </div>

      </div>

    </div>

    <div id="subway_container" :style="mapHeight">
      <!-- <el-amap-search-box class="search-box" :search-option="searchOption" :on-search-result="onSearchResult"></el-amap-search-box> -->
      <el-amap class="amap-box" vid="real_map" ref="real_map" :zoom="zoom" :center="center" :amap-manager="amapManager"
        :plugin="plugin" :events="events">
        <el-amap-polyline editable=false :path="dots" strokeColor="blue" strokeWeight=2></el-amap-polyline>
        <!-- <el-amap-marker :vid="'real_search_marker' + index" v-for="(marker,index) in markers" :key="index" :position="[marker.lng,marker.lat]" :events="searchMarkerEvents"></el-amap-marker> -->
        <el-amap-marker :vid="'lnglat_marker' + index" v-for="(pos,index) in lnglatObj" :key="index"
          :position="pos.split('|')" :events="lnglatMarkerEvents" icon='./../../static/images/marker1.png'
          :draggable="true" :offset=[-16,-27]></el-amap-marker>
        <el-amap-marker :vid="'station_marker' + index" v-for="(pos,index) in stationList" :key="'station' + index"
          :position="pos.position" :events="stationMarkerEvents" icon="./../../static/images/marker.png" zIndex=101
          :draggable="true" :offset=[-16,-27] :label="{'content': pos.name, 'offset': [15, -5]}"></el-amap-marker>
        <el-amap-marker :vid="'name_marker' + index" v-for="(pos,index) in mark" :key="'name' + index" zIndex=102
          :position="pos.split('|')" :events="nameMarkerEvents" icon="./../../static/images/notdb.png"
          :draggable="true" :offset=[-16,-27]></el-amap-marker>
      </el-amap>
    </div>

  </div>
</template>

<script>
  import {
    AMapManager
  } from "vue-amap"
  let amapManager = new AMapManager();
  export default {
    data() {
      return {
        name: '',  // 线路名
        subway_id: '',
        lnglatObj: [], //画点的
        dots: [], //画线的
        stationList: [], //站点
        showRenameInput: '',
        dragging: null,


        mapHeight: {},

        searchOption: {
          city: '杭州',
          citylimit: true
        },
        zoom: 15,
        center: [120.051238, 30.228232],
        amapManager,
        events: {
          'rightclick': (e) => {
            let that = this
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.dots.push(dot)
            that.lnglatObj.push(dot.join('|'))
          },
          'click': (e) => {
            let that = this
            let dot = [e.lnglat.lng, e.lnglat.lat]
            if (that.mode === '出入口') {
              that.stationList.push({
                position: dot,
                name: '入口'
              })
            } else {
              that.mark.push(dot.join('|'))
            }
          }
          
        },
        plugin: [{
          //地图类型，卫星地图和普通地图
          pName: 'MapType',
          defaultType: 0,
        }],
        markers: [],

        lnglatMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            that.dots.splice(index, 1)
            that.lnglatObj.splice(index, 1)
          },
          'click': (e) => {
            let that = this
            let index = Number(e.target.w.vid.replace('lnglat_marker', ''))
            console.log('index', index)
            if (that.chaifen) {
              if (that.chaiList.length === 0) {
                that.chaiList.push(index);
              } else {
                that.chaiList.push(index);
                that.endChai();
              }
            } else {
              let dot = that.lnglatObj[index].split('|')
              if (that.mode === '出入口') {
                that.stationList.push({
                  position: dot,
                  name: '入口'
                })
              } else {
                that.mark.push(that.lnglatObj[index])
              }
            }
          },
          'dragging': (e) => {
            let that = this
            let index = e.target.w.vid.replace('lnglat_marker', '')
            let dot = [e.lnglat.lng, e.lnglat.lat]
            that.dots.splice(index, 1, dot)
            that.lnglatObj.splice(index, 1, dot.join('|'))
          }
        },
        stationMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('station_marker', '')
            that.stationList.splice(index, 1)
          }
        },
        nameMarkerEvents: {
          'rightclick': (e) => {
            let that = this
            let index = e.target.w.vid.replace('name_marker', '')
            that.mark.splice(index, 1)
          }
        },

        mode: '出入口',  // 当前模式是标记出入口还是标识线路名

        mark:[],  //标记线路名的点的 index 放这里

        status: '',

        type: '',

        chaifen: false,

        chaiList: []

      }
    },
    created() {
      let height = window.innerHeight + 'px';
      console.log(height)
      this.mapHeight.height = height
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        delete origin.mapHeight;
        delete origin.events;
        delete origin.lnglatMarkerEvents;
        delete origin.stationMarkerEvents;
        delete origin.nameMarkerEvents;
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this;
        let obj = that.$route.params
        console.log('obj', obj)
        if (obj.id) {

          that.$axios.get(that.$url_prefix + 'queryOneById', {
            params: {
              id: obj.id,
              db: 'HighwayModel'
            }
          }).then(function (res) {
            console.log('query back',res)
            let one = res.data.data;
            if (one.mark) {
              that.mark = one.mark.split('-');
            }
            that.name = one.name
            that.subway_id = one.id
            that.lnglatObj = one.dots.split('-')
            let temp = one.dots.split('-')
            for (let i = 0; i < temp.length; i++) {
              temp[i] = temp[i].split('|')
            }
            that.dots = temp
            that.stationList = JSON.parse(one.station)
            that.center = that.dots[0]
            that.status = one.status || '';
            that.type = one.type || '';

          }).catch(function (res) {
            console.log('err', res)
            alert('查询失败，请检查网络')
          })

        } else {
          console.log('没有信息')
        }

      },
      //地图搜索的回调
      onSearchResult(pois) {
        if (pois.length > 0) {
          let {
            lng,
            lat
          } = pois[0];
          this.markers = pois;
          this.center = [lng, lat];

        }
      },


      //上传数据库
      upToDb() {
        let that = this

        let obj = {}

        if (that.name.length === 0) {
          alert('请填写高架名称')
          return;
        }
        if (that.type.length === 0) {
          alert('请选择类别')
          return;
        }
        if (that.lnglatObj.length === 0) {
          return;
        }
        if (that.mark.length > 0) {
          obj.mark = that.mark.join('-');
        } else {
          obj.mark = ''
        }
        obj.name = that.name
        obj.dots = that.lnglatObj.join('-')
        obj.station = JSON.stringify(that.stationList)
        obj.status = that.status;
        obj.type = that.type;

        if (that.subway_id.length > 0) {
          obj.id = that.subway_id
        }

        let param = {
          'db': 'HighwayModel',
          'model': 'edit',
          'item': JSON.stringify(obj),
        }
        that.$axios.post(that.$url_prefix + 'updateData', param).then(function (want) {
          console.log('update back', want)
          that.$router.push({
            path: '/IndexPage'
          })
        }).catch(function (res) {
          console.log('update fail', res);
        })

      },

      changeCenter(station) {
        this.center = station.position
      },
      del(index) {
        let temp = this.stationList.splice(index, 1)[0]
      },
      rename1(index) {
        let that = this
        that.showRenameInput = index
        // that.renameText = that.tagList[index].name
      },
      rename2(index) {
        let that = this
        // that.tagList[index].name = that.renameText
        that.showRenameInput = ''
      },
      loseFocus() {
        this.showRenameInput = ''
      },

      changeMode(mode){
        this.mode = mode;
      },

      reverseLine() {
        this.lnglatObj.reverse();
        this.dots.reverse();
        this.$message({
          message: '反转成功',
          type: 'success'
        })
      },

      sortStations() {
        let stationList = JSON.parse(JSON.stringify(this.stationList));
        let list = [];
        list.push(stationList.splice(0,1)[0]);
        
        while (stationList.length > 0) {
          let last = list[list.length - 1];
          let minDis = 1000000;
          let minIndex = -1;
          for (let i=0; i<stationList.length; i++) {
            let dis = AMap.GeometryUtil.distance(stationList[i].position, last.position);
            if (dis < minDis) {
              minDis = dis;
              minIndex = i;
            }
          }
          if (minIndex > -1) {
            list.push(stationList.splice(minIndex,1)[0]);
          } else {
            console.log('err');
            return;
          }
        }
        if (JSON.stringify(list) === JSON.stringify(this.stationList)) {
          this.$message({
            type: 'success',
            message: '已经是正确顺序'
          })
        } else {
          this.stationList = list;
          this.$message({
            type: 'success',
            message: '排序成功'
          })
        }
        console.log('sort over');
      },

      toTop(index) {
        this.stationList.unshift(this.stationList.splice(index,1)[0]);
        this.$message({
            type: 'success',
            message: '置顶成功'
          })
      },

      startChai() {
        this.chaifen = true;
      },
      endChai() {
        let that = this;
        let list = that.chaiList;
        if (list.length === 2 && Math.abs(list[0] - list[1]) > 1) {
          list.sort((a,b) => a - b);
          let start = Number(list[0]);
          let end = Number(list[1]);

          let obj = {};
          let lnglat = that.lnglatObj.slice(start,end + 1);
          obj.name = that.name;
          obj.dots = lnglat.join('-')
          obj.station = JSON.stringify(that.stationList)
          obj.status = that.status;
          obj.type = that.type;
          that.lnglatObj.splice(start+1,end - start - 1);
          that.dots.splice(start+1,end - start - 1);
          let param = {
            'db': 'HighwayModel',
            'model': 'edit',
            'item': JSON.stringify(obj),
          }
          that.$axios.post(that.$url_prefix + 'updateData', param).then(function (want) {
            console.log('update back', want)
            that.chaifen = false;
            that.chaiList = [];
            that.$message({
              type: 'success',
              message: '拆分成功'
            })
          }).catch(function (res) {
            console.log('update fail', res);
          })
        } else {
          that.$message.error('点不对');
          that.chaiList = [];
          that.chaifen = false;
        }
      }

    }
  }

</script>

<style scoped>

  .realEstate {
    display: flex;
    width: 100%;
    user-select: none;
  }

  .realEstate .edit-area {
    text-align: center;
    width: 30%;
  }

  .realEstate #subway_container {
    width: 70%;
    position: fixed;
    top: 0;
    left: 30%;
  }

  #subway_container .search-box {
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid black;
  }

  .imageBox {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
  }

  .imageBox .imageItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
  }

  img {
    height: 100px;
    width: 100px;
    vertical-align: bottom;
  }

  .up {
    margin-top: 20px;
    width: 150px;
    height: 50px;
    border-radius: 10px
  }

  .adImg {
    height: 100px;
  }

  .line {
    margin-top: 20px;
    color: #ccc;
  }

  .normal {
    margin: 10px 0;
  }

  .white {
    height: 50px;
  }

  .salesmanList {
    display: flex;
    flex-wrap: wrap;
  }

  .salesman {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 20px;
  }

  .salesman img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .bgred{
    background-color: red;
  }

</style>



// WEBPACK FOOTER //
// src/page/highway.vue